module.exports = __webpack_public_path__ + "img/z- (1)_Moment.8c3a1cbd.jpg";